export default __webpack_public_path__ + "static/media/DE-CompanyProfile.3d45aee3.pdf";